import { render, staticRenderFns } from "./ContentPageLayout.vue?vue&type=template&id=0dddf074"
import script from "./ContentPageLayout.vue?vue&type=script&lang=js"
export * from "./ContentPageLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports